import Main from './Main/main'
import Setting from './Setting/Setting'
import PrescriptionDashboard from './Prescription/PrescriptionDashboard'
import Timesheet from './Timesheet/Timesheet'
import Card from '../share/Components/Card/Card'
import Appointment from './Appointment/Appointment'
import AppointmentCard from '../share/Components/Card/AppointmentCard'
import ManagementDashboard from './Management/ManagementDashboard'
import VisitReport from './Management/VisitReport'
import TicketReport from './Management/TicketReport'
import PaymentsReport from './Management/PaymentsReport'
import InsuranceSharePaymentsReport from './Management/InsuranceSharePaymentsReport'
import Login from './Logins/Login'
import TicketRequest from './TicketRequest/TicketRequest'
import Reports from './Insurances/Insurances'
import Tamin from './Insurances/Tamin/Tamin'
import IHIO from './Insurances/IHIO/IHIO'
import ListSamad from './Insurances/IHIO/ListSamad'
import PreviewPrescription from './Prescription/PreviewPrescription'
import Chat from './Chat/Chat'
import Support from './Support/Support'
export {
  Support,
  Chat,
  PreviewPrescription,
  ListSamad,
  Tamin,
  IHIO,
  Reports,
  TicketRequest,
  Login,
  AppointmentCard,
  Appointment,
  Card,
  Setting,
  PrescriptionDashboard,
  Timesheet,
  ManagementDashboard,
  VisitReport,
  TicketReport,
  PaymentsReport,
  InsuranceSharePaymentsReport,
}
export default Main
